import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps"

export default {
	getCurrentUser: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].GET_CURRENT_USER
	},
	getAvailableCompanies: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].GET_AVAILABLE_COMPANIES,
	},
	getPermissions: {
		useCache: false,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].GET_PERMISSIONS
	},
	putUser:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].PUT_USER
	},
	patchUser:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].PATCH_USER
	},
	setPassword:{
		apiServiceMethodName: ModulesConfigMap[ModulesMap.USER].SET_PASSWORD
	},
}
